import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-100/70', text: 'text-primary-700', border: 'border-primary-200' },
  accent: { bg: 'bg-accent-100/80', text: 'text-accent-900', border: 'border-accent-200' },
  secondary: { bg: 'bg-secondary-100/80', text: 'text-secondary-900', border: 'border-secondary-200' },
};

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            八大风格分类，帮助你精准找到感兴趣的里番动漫与漫画内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group ${colors.bg} border ${colors.border} rounded-lg p-5 hover:scale-[1.02] transition-all duration-300 flex flex-col items-center text-center`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${colors.bg} ${colors.text} mb-3 group-hover:scale-110 transition-transform`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className={`text-base font-semibold font-heading ${colors.text} mb-2`}>
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {cat.description}
                </p>
                <span className={`inline-flex items-center gap-1 text-xs ${colors.text} mt-3 font-medium whitespace-nowrap`}>
                  浏览分类
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}